import { SOItemFormValues } from "constants/types/salesOrder";

export const calcItemTotal = (
  quantity: number | string,
  actualPrice: number | string,
): number => Number(quantity || 0) * Number(actualPrice || 0);

export const calcOrderTotal = (items: SOItemFormValues[]): number =>
  items.reduce((sum, item) => sum + calcItemTotal(item.quantity, item.actualPrice), 0);

export const formatCurrency = (value: number): string =>
  value.toLocaleString("vi-VN") + " ₫";
